module.exports = __webpack_public_path__ + "static/tamanplus-black-455126575143196fbce8e4f40fa1cb29.svg";